'use client';

import React, { useEffect, useState, useCallback } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';


const TabSectionPremium: React.FC = React.memo(() => {
  const [activeTab, setActiveTab] = useState('1');
  const router = useRouter();
  const pathname = usePathname();
  const url = pathname ? pathname.split('/')[2] : '';

  const toggle = (pageName: string) => {
    router.push(`/help/${pageName}`);
  };

  const determineActiveTab = useCallback(() => {
    if (url === 'premium-training') {
      return '2';
    } else if (url === 'contact-premium') {
      return '3';
    } else {
      return '1';
    }
  }, [url]);

  useEffect(() => {
    setActiveTab(determineActiveTab());
  }, [url, determineActiveTab]);


  return (
    <div className='container tab-section-premium'>
      <Nav pills>
        <NavItem className='cursor-pointer'>
          <NavLink
            className={classnames('bg-white text-sm', { active: activeTab === '1' })}
            onClick={() => { toggle('faq'); }}
          >
            FAQs
          </NavLink>
        </NavItem>
        {/* <NavItem className='cursor-pointer'>
          <NavLink
            className={classnames('bg-white mx-1', { active: activeTab === '2' })}
            onClick={() => { toggle('premium-training'); }}
          >
            Reconsideration
          </NavLink>
        </NavItem> */}
        <NavItem className='cursor-pointer'>
          <NavLink
            className={classnames('bg-white', { active: activeTab === '3' })}
            onClick={() => { toggle('contact-premium'); }}
          >
            Contact Premium
          </NavLink>
        </NavItem>
      </Nav>
    </div>
  );
});

export default TabSectionPremium;

